"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M11.924 1c-.257 0-.452.085-.667.26v.001L.443 10.006l-.001.002a1.215 1.215 0 0 0-.442.941V21.3C0 22.79 1.183 24 2.655 24h18.69C22.808 24 24 22.78 24 21.29V10.94c0-.366-.159-.71-.442-.942L12.742 1.27l-.004-.003c-.15-.117-.424-.267-.665-.267h-.15ZM12 11.517a3.178 3.178 0 0 0-3.184 3.18v3.913c0 .135.11.244.245.244h5.878c.135 0 .245-.11.245-.244v-3.914A3.178 3.178 0 0 0 12 11.516Z",
    clipRule: "evenodd"
  })]
});